/* export const conf = {
    api: {                                              // ==>==>==> API configuration <==<==<==
        authzAutorisation: {                                        // ==>==>==> API authZ autorisation configuration <==<==<==
            basePath: buildUrlSettings('authz', '/api/authz/autorisation/v4')
        },
    },
}; */

/**
 * Conf to build url settings
 */
function buildUrlSettings(appName: string, baseUrl: string) {

  const regex = /^[^.]+(\..+\..+\..+)$/;
  let domain = '.dev.pc-scol.fr';
  if (window.location.hostname.match(regex)) {
    domain = window.location.hostname.replace(regex, '$1');
  }
  const urlApiRequest = `https://${appName}${domain}${baseUrl}`;

  return urlApiRequest;
}

/***************************************************************************************/
export interface AuthzConfigParameters {
  /**
   * stubMode: true pour renvoyer toujours true sans vérifier les traitements
   */
  mode?: AuthzMode; // valoriser à true pour autoriser l'utilisateur sur tous les modules et tous les traitements (développement local)
  url?: string; // url du serveur authz
  code_module?: string | string[]; // code de traitement de l'accès au module
  select_etab_uri?: string; // url vers laquelle rediriger l'utilisateur si il doit sélectionner un établissement
  missing_module_access_uri: string; // url vers laquelle rediriger l'utilisateur si il n'a pas accès au module
  enableModuleAccessCheck?: boolean; // vérifie que l'utilisateur a le droit d'accéder au module Pegase
  // si il n'a pas les droits, alors l'utilisateur est redirigé
  // vers missing_module_access_uri après l'authentification
  // Valeur par défaut: true
  useExtensions?: boolean;  // Permet à une librairie tierce d'effectuer des traitements
  // durant l'authentification de l'utilisateur.
  // - si true: la lib émet l'action ngrx AuthzExtensionBeforeInit
  //   cette action devra être gérée côté utilisateur du module ng-auth
  //   pour effectuer des traitements d'initialisation
  //   une fois ces traitements effectués, la librairie doit
  //   émettre l'action AuthzExtensionBeforeBeforeInitResponse
  //   pour que l'authentification soit finalisée
  // - si false, l'évènement AuthzExtensionBeforeInit n'est pas
  //   émis
  // par défaut false
}

export type AuthzMode = 'rest' | 'stub';

/**
 * AuthzConfig est l'objet à utiliser dans les applications clientes pour configurer la librairie
 */
export class AuthzConfig implements AuthzConfigParameters {
  url?: string ;
  code_module?: string[];
  select_etab_uri?: string;
  missing_module_access_uri: string;
  enableModuleAccessCheck: boolean;
  useExtensions: boolean;
  mode: AuthzMode;

  constructor({
                url,
                code_module,
                select_etab_uri,
                missing_module_access_uri,
                enableModuleAccessCheck = true,
                useExtensions = false,
                mode = 'rest',
              }: AuthzConfigParameters) {
    this.code_module = this.code_moduleValue(code_module);
    this.mode = mode ?? 'rest';
    if (missing_module_access_uri == null) {
      throw new Error('Configuration authz invalide, clé missing_module_access_uri manquante');
    }
    this.missing_module_access_uri = missing_module_access_uri;
    this.select_etab_uri = select_etab_uri ?? missing_module_access_uri;
    this.enableModuleAccessCheck = enableModuleAccessCheck;
    this.useExtensions = useExtensions;
    if (url != null) {
      this.url = url + (url.endsWith('/') ? '' : '/') + 'api/authz/autorisation/v5';
    } else {
      console.warn(`Configuration automatique dépréciée, valoriser la propriété url de AuthzConfigParameters`);
      this.url = buildUrlSettings('authz', '/api/authz/autorisation/v5');
    }
  }

  private code_moduleValue(code_module?: string | string[]): string[] | undefined {
    if (code_module === undefined) {
      return undefined;
    } else if (typeof code_module === 'string') {
      return [code_module];
    } else {
      return code_module;
    }
  }
}



